// Shown to limited (church-card) guests for every page outside their galleries.
// The server refuses the data anyway; this just says so plainly and points home.
import React from 'react';
import { Link } from '../router.jsx';
import { FORBIDDEN } from '../text.js';

export default function Forbidden() {
	return (
		<div className='notfound'>
			<h1 className='notfound__title'>{FORBIDDEN.title}</h1>
			<p>{FORBIDDEN.text}</p>
			<Link to='/' className='btn btn--primary'>
				{FORBIDDEN.button}
			</Link>
		</div>
	);
}
